export const reportDWHBuilder = (mode, params, props) => {
  const { magicLinkParameters, userDetails } = props;

  const defaultReport = {
    area: 'SelfCare',
    subArea: 'SettingPaymentEntity',
    channel: 'WebsitePrivate',
    status: '',
    customerName: params?.Customer_Name || magicLinkParameters?.fullName || '',
    subscriber: params?.SUBSCRIBER || '',
    contactId: params?.ID_NUMBER || '',
    actionType: '',
    messageText: '',
    param1: params?.oldCreditCardLast4 || '',
    param2: params?.accountsToUpdate || '',
    param3: params?.smsPhoneNumber || '',
    param4: params?.newPaymentMethodLast4 || '',
    param5: '',
    param6: '',
    param7: '',
    param8: '',
    param9: params?.param9 || params?.subscriberNumber || '',
    param10: params?.param10 || params?.step || '',
    banId: params?.BAN || '',
    psId: params?.SUBSCRIBER || '',
    cmrId: '',
    email: '',
  };

  const reports = {
    ENTITY_PAYMENT_ENTRANCE: {
      status: 'Ongoing',
      actionType: 'Payment Setting Entrance',
      messageText: 'Payment Setting Displayed',
    },
    SMS_COMPONENT_TRIGGERED: {
      status: 'Ongoing',
      actionType: 'SettingPaymentEntity Entrance',
      messageText: 'SettingPaymentEntity Displayed',
    },
    SMS_SENT_SUCCESSFULLY: {
      status: 'Completed',
      actionType: 'SettingPaymentEntity Invitation',
      messageText: 'SettingPaymentEntity Invitation Sent',
    },
    ENTITY_PAYMENT_SUCCESS: {
      status: 'Completed',
      actionType: 'Payment Update',
      messageText: 'Payment Update Success',
    },
    ENTITY_PAYMENT_FAILURE: {
      status: 'Error',
      actionType: 'Payment Update',
      messageText: 'General Error',
    },
  };

  const report = reports[mode] || {};
  return { ...defaultReport, ...report };
};
